<template>
    <div class="index container">
        <button class="btn-test" v-on:click="changeMyPie">更新数据1</button>
        <div class="map-contain">
            <mapCharts :list="list" :level="level" />
        </div>
        <div class="map-contain">
            <mapChartsVisual :list="listVisual" />
        </div>
        <div class="rank-contain">
            <rankCharts :rankList="rankList" />
        </div>
        <div class="line-contain">
            <lineCharts :data="data" :color="color" />
        </div>
        <div class="line-contain">
            <doubleLineCharts :doubleData="doubleData" />
        </div>
        <div class="line-contain">
            <pieCharts ref="myPie" :pieData="pieList" :pieRatio="pieRatio" />
        </div>
        <div class="line-contain">
            <pieChartsInfeed :pieData="pieInfeedList" />
        </div>
        <div class="line-contain">
            <pieChartsInfeedLong :pieData="pieInfeedList" />
        </div>
        <div class="line-contain">
            <columnChartsInfeed :experience="experienceList" :quality="qualityList" :standard="standardList" />
        </div>
        <div class="line-contain">
            <medicinePieCharts :pieData="medicinePieList" :color="colorList" />
        </div>
        <div class="line-contain">
            <columnCharts :columnData="columnList" :xAxis="columnX" />
        </div>
        <div class="radar-contain">
            <radarCharts :radarData="radarList1" />
        </div>
        <div class="radar-contain">
            <radarCharts :radarData="radarList2" />
        </div>
        <div class="rank-contain">
            <sortRankCharts :rankList="rankList" />
        </div>
        <div class="rank-contain">
            <grayRankCharts :rankList="rankList"/>
        </div>
  </div>
</template>

<script>

    import mapCharts from '../../components/MapCharts';
    import mapChartsVisual from '../../components/MapChartsVisual';
    import grayRankCharts from '../../components/grayRankCharts';
    import rankCharts from '../../components/RankCharts';
    import sortRankCharts from '../../components/sortRankCharts';
    import lineCharts from '../../components/LineCharts';
    import doubleLineCharts from '../../components/DoubleLineCharts';
    import pieCharts from '../../components/PieCharts';
    import pieChartsInfeed from '../../components/PieChartsInfeed';
    import pieChartsInfeedLong from '../../components/PieChartsInfeedLong';
    import medicinePieCharts from '../../components/MedicinePieCharts';
    import columnCharts from '../../components/ColumnCharts';
    import radarCharts from '../../components/RadarCharts';
    import columnChartsInfeed from './components/SinceritySubdivisionBar';
    export default {
        name: 'index',
        components: {
            sortRankCharts,
            mapCharts,
            grayRankCharts,
            rankCharts,
            lineCharts,
            doubleLineCharts,
            pieCharts,
            medicinePieCharts,
            columnCharts,
            radarCharts,
            pieChartsInfeed,
            pieChartsInfeedLong,
            columnChartsInfeed,
            mapChartsVisual
        },
        data () {
            return {
                list: [
                    { 'name': '昆明市', 'value': 30 },
                    { 'name': '曲靖市', 'value': 10 },
                    { 'name': '玉溪市', 'value': 2 },
                    { 'name': '保山市', 'value': 20 },
                    { 'name': '昭通市', 'value': 30 },
                    { 'name': '丽江市', 'value': 40 },
                    { 'name': '普洱市', 'value': 60 },
                    { 'name': '临沧市', 'value': 20 },
                    { 'name': '楚雄彝族自治州', 'value': 30 },
                    { 'name': '红河哈尼族彝族自治州', 'value': 30 },
                    { 'name': '文山壮族苗族自治州', 'value': 50 },
                    { 'name': '西双版纳傣族自治州', 'value': 70 },
                    { 'name': '大理白族自治州', 'value': 6 },
                    { 'name': '德宏傣族景颇族自治州', 'value': 6 },
                    { 'name': '怒江傈僳族自治州', 'value': 6 },
                    { 'name': '迪庆藏族自治州', 'value': 2 }
                ],
                listVisual: [
                    { 'name': '昆明市', 'value': 3 },
                    { 'name': '曲靖市', 'value': 1 },
                    { 'name': '玉溪市', 'value': 2 },
                    { 'name': '保山市', 'value': 2 },
                    { 'name': '昭通市', 'value': 3 },
                    { 'name': '丽江市', 'value': 4 },
                    { 'name': '普洱市', 'value': 6 },
                    { 'name': '临沧市', 'value': 2 },
                    { 'name': '楚雄彝族自治州', 'value': 3 },
                    { 'name': '红河哈尼族彝族自治州', 'value': 3 },
                    { 'name': '文山壮族苗族自治州', 'value': 5 },
                    { 'name': '西双版纳傣族自治州', 'value': 7 },
                    { 'name': '大理白族自治州', 'value': 6 },
                    { 'name': '德宏傣族景颇族自治州', 'value': 6 },
                    { 'name': '怒江傈僳族自治州', 'value': 6 },
                    { 'name': '迪庆藏族自治州', 'value': 2 }
                ],
                level: [
                    { 'min': 51, 'color': 'rgba(54,179,116,1)' },
                    { 'min': 11, 'max': 50, 'color': 'rgba(54,179,116,0.7)' },
                    { 'min': 6, 'max': 10, 'color': 'rgba(54,179,116,0.4)' },
                    { 'min': 0, 'max': 5, 'color': 'rgba(54,179,116,0.1)' }
                ],
                rankList: [
                    { 'id': 1, 'city': '昆明市', 'cityShortName': '昆明市', 'mark': '90.00', 'change': 1, 'changeRank': 2 },
                    { 'id': 2, 'city': '西双版纳州', 'mark': '80.00', 'change': 2, 'changeRank': 2 },
                    { 'id': 3, 'city': '昆明市', 'mark': '72.30', 'change': 1, 'changeRank': 2 },
                    { 'id': 4, 'city': '昆明市', 'mark': '60.00', 'change': 2, 'changeRank': 2 },
                    { 'id': 5, 'city': '昆明市', 'mark': '50.00', 'change': 0, 'changeRank': 2 },
                    { 'id': 6, 'city': '昆明市', 'mark': '30.00', 'change': 1, 'changeRank': 2 }
                ],
                // 折线图
                data: [
                    { 'xAxis': '1', 'num': '290' },
                    { 'xAxis': '2', 'num': '330' },
                    { 'xAxis': '3', 'num': '100' },
                    { 'xAxis': '4', 'num': '220' },
                    { 'xAxis': '5', 'num': '150' },
                    { 'xAxis': '6', 'num': '300' },
                    { 'xAxis': '7', 'num': '420' },
                    { 'xAxis': '8', 'num': '180' },
                    { 'xAxis': '9', 'num': '290' },
                    { 'xAxis': '10', 'num': '120' },
                    { 'xAxis': '11', 'num': '290' },
                    { 'xAxis': '12', 'num': '330' },
                    { 'xAxis': '13', 'num': '100' },
                    { 'xAxis': '14', 'num': '220' },
                    { 'xAxis': '15', 'num': '150' },
                    { 'xAxis': '16', 'num': '300' },
                    { 'xAxis': '17', 'num': '420' },
                    { 'xAxis': '18', 'num': '180' },
                    { 'xAxis': '19', 'num': '290' },
                    { 'xAxis': '20', 'num': '120' }
                ],
                color: 'green',
                // 双折线图
                doubleData: [
                    { 'xAxis': '1月', 'left': '35', 'right': '1' },
                    { 'xAxis': '2月', 'left': '15', 'right': '1' },
                    { 'xAxis': '3月', 'left': '8', 'right': '2' },
                    { 'xAxis': '4月', 'left': '12', 'right': '4' },
                    { 'xAxis': '5月', 'left': '11', 'right': '2' },
                    { 'xAxis': '6月', 'left': '6', 'right': '1' },
                    { 'xAxis': '7月', 'left': '3', 'right': '3' },
                    { 'xAxis': '8月', 'left': '10', 'right': '6' },
                    { 'xAxis': '9月', 'left': '15', 'right': '6' },
                    { 'xAxis': '10月', 'left': '2', 'right': '6' },
                    { 'xAxis': '11月', 'left': '24', 'right': '2' },
                    { 'xAxis': '12月', 'left': '20', 'right': '1' }
                ],
                // 饼图
                pieList: [
                    { 'value': 90, 'name': '完成量' },
                    { 'value': 10, 'name': '总数量' }
                ],
                pieRatio: '90',
                // 首页全屏饼图
                pieInfeedList: [
                    { value: 268, name: '7分及以上' },
                    { value: 107, name: '≥6分且<7分' },
                    { value: 25, name: '6分以下(不含)' }
                ],
                // 实心饼图
                medicinePieList: [
                    { value: 50, name: '在线投诉' },
                    { value: 60, name: '电话质量' },
                    { value: 70, name: '系统质量' },
                    { value: 80, name: '语音质量' }
                ],
                colorList: ['#36B374', '#FF8C19', '#FF4D4D', '#2283E6'],
                // 堆叠柱状图
                columnList: [
                    { 'type': '线上使用中', 'stack': '线上企业', 'data': [320, 332, 301, 334, 390], 'color': 'rgba(54,179,116,1)' },
                    { 'type': '线上待激活', 'stack': '线上企业', 'data': [120, 132, 101, 134, 90], 'color': 'rgba(54,179,116,0.4)' },
                    { 'type': '线下使用中', 'stack': '线下企业', 'data': [220, 182, 191, 234, 290], 'color': 'rgba(255,140,25,1)' },
                    { 'type': '线下待激活', 'stack': '线下企业', 'data': [150, 232, 201, 154, 190], 'color': 'rgba(255,140,25,0.4)' }
                ],
                columnX: ['旅行社', '酒店', '景区', '餐饮', '其他'],
                // 雷达图
                radarList1: [
                    { name: '品质指数', max: 10, value: 7.6 },
                    { name: '体验指数', max: 10, value: 8.2 },
                    { name: '规范指数', max: 10, value: 10 }
                ],
                radarList2: [
                    { name: '旅行社', max: 150, value: 96 },
                    { name: '其他', max: 150, value: 121 },
                    { name: 'OTA', max: 150, value: 121 },
                    { name: '购物', max: 150, value: 87 },
                    { name: '交通', max: 150, value: 94 },
                    { name: '景区', max: 150, value: 50 },
                    { name: '餐饮', max: 150, value: 55 },
                    { name: '酒店', max: 150, value: 114 }
                ],
                // 横屏柱状图
                experienceList: [10, 52, 200, 334, 390, 330, 220, 120, 190, 250],
                qualityList: [100, 52, 100, 334, 390, 130, 220, 120, 290, 150],
                standardList: [200, 52, 200, 234, 290, 130, 320, 220, 190, 250]
            }
        },
        computed: {

        },
        watch: {

        },
        methods: {
            changeMyPie () {
                // 圆环图
                let newPie = [
                    { 'value': 80, 'name': '完成量' },
                    { 'value': 20, 'name': '总数量' }
                ]
                this.pieList = newPie
                // 折线图
                let newLine = [
                    { 'xAxis': '1', 'num': '290' },
                    { 'xAxis': '2', 'num': '200' },
                    { 'xAxis': '3', 'num': '100' },
                    { 'xAxis': '4', 'num': '220' },
                    { 'xAxis': '5', 'num': '150' },
                    { 'xAxis': '6', 'num': '300' },
                    { 'xAxis': '7', 'num': '320' },
                    { 'xAxis': '8', 'num': '180' },
                    { 'xAxis': '9', 'num': '290' },
                    { 'xAxis': '10', 'num': '120' },
                    { 'xAxis': '11', 'num': '290' },
                    { 'xAxis': '12', 'num': '330' },
                    { 'xAxis': '13', 'num': '100' },
                    { 'xAxis': '14', 'num': '220' },
                    { 'xAxis': '15', 'num': '150' },
                    { 'xAxis': '16', 'num': '300' },
                    { 'xAxis': '17', 'num': '320' },
                    { 'xAxis': '18', 'num': '180' },
                    { 'xAxis': '19', 'num': '290' },
                    { 'xAxis': '20', 'num': '120' }
                ]
                this.data = newLine
                // 堆叠柱状图
                let newColumn = [
                    { 'type': '线上使用中', 'stack': '线上企业', 'data': [120, 132, 101, 134, 190], 'color': 'rgba(54,179,116,1)' },
                    { 'type': '线上待激活', 'stack': '线上企业', 'data': [120, 132, 101, 134, 90], 'color': 'rgba(54,179,116,0.4)' },
                    { 'type': '线下使用中', 'stack': '线下企业', 'data': [220, 182, 191, 234, 290], 'color': 'rgba(255,140,25,1)' },
                    { 'type': '线下待激活', 'stack': '线下企业', 'data': [150, 232, 201, 154, 190], 'color': 'rgba(255,140,25,0.4)' }
                ]
                let newXa = ['旅行社', '酒店', '景区', '餐饮', '其他她']
                this.columnList = newColumn
                this.columnX = newXa
            }
        },
        mounted () {
        },

        created () {
        }

    }
</script>

<style lang="less" scoped>
.container{
    width: 100%;
    height: 100%;
    padding: 0 12px;
    .map-contain{
        height: 280px;
    }
    .rank-contain{
        height: 250px;
    }
    .line-contain{
        height: 250px;
    }
    .radar-contain{
        height: 400px;
        margin-top: 50px;
    }
    .btn-test{
        width: 100px;
        height: 50px;
        z-index: 99;
    }
}
</style>
